import { IInventoryPage } from '../inventory-page.interface';


export const TUTORIALS_PAGE: IInventoryPage = {
	'route': '/tutorials',
	'title': 'Tutorials',
	'uiReference': [
		'Search tutorials',
		'Clear tutorial search',
		'Search tutorials &times;'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/tutorials-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/overview/overview.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/tutorials/overview/overview.component.html'
	],
	'aliases': []
};
